import React from 'react';
import { Layout } from 'antd';
import './style.css'
import UserHeader from '../../Header/UserHeader';

const { Content } = Layout;

const UserLayout = ({ children }) => {

    return (
        <Layout>
            <UserHeader />
            <Content
                className='p-2 px-4 md:px-8 min-h-screen max-w-7xl mx-auto w-full'>
                {children}
            </Content>
        </Layout>
    );
};
export default UserLayout;